import { render, staticRenderFns } from "./RefuseRequest.vue?vue&type=template&id=2f05c989&"
import script from "./RefuseRequest.vue?vue&type=script&lang=js&"
export * from "./RefuseRequest.vue?vue&type=script&lang=js&"
import style0 from "./RefuseRequest.vue?vue&type=style&index=0&id=2f05c989&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports